import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/teams";

export const getTeamById = (id) => {
  return jeepRallyApi.get(`${baseUrl}/${id}`);
};

export const getTeamsByEvent = (eventId, params = {}) => {
  return jeepRallyApi.get(`${baseUrl}/event/${eventId}`, { params });
};
